module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAABD0lEQVR4Ae3VAURDURiG4ZOSpAQBVEJACACQCCIAigplFCFAregMCSKhwQIRBACCECACoEEIgxCFkNoTMFeGezsD2Qv48AC/P6TXzawoig5ToQpAKJIDux2AbEOWMqgGYCQ/tEWWsuwTAG+ODP+J0u8W2R6N5aV2ZKkBFyoWrTjxCup6i1I7v/YJH2Az5M1ue8o1uAz5c9eOMi+KNopAp7SolMzQKaraIUqPkvc0qpVJNc+ArZCaNc1/RNkXRdPJlHtwlt0sKU45Bl/mMtuoJwpShtRB05VNCzace4Hi1LgH7brxDdbzU33KGrI1lEKwqomm9WKHUgUw1VpLYDsUSQTIrvaUQ0iC0l92DIl1+wElicQwODuLfAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/support.png
// module id = RIzJ
// module chunks = 1